import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import BannerImg from '../../../../common/assets/images//contests/contests_banner.png';
import LoadingSpinner from '../../../../common/widgets/LoadingSpinner';
import { resources } from '../../resources/resources';
import { ContestBanner } from '../HomePage/Contest/ContestBanner';
import { CustomerInfoContext } from '../../contexts/CustomerInfoContext';

export const ContestsPage = () => {
  const { customerInfo } = useContext(CustomerInfoContext);
  const { t: translate } = useTranslation();

  const contests = customerInfo?.contests;

  if (contests === undefined) return <LoadingSpinner />;

  if (!contests?.length) return null;

  return (
    <section className="section-main section-full">
      <div className="container">
        <div className="discover-header">
          <div className="contest-top-banner">
            <div className="contest-top-banner-copy">
              <div className="contest-top-banner-title">
                {translate(resources.contests.banner.title)}
              </div>
              <div className="contest-top-banner-description">
                {translate(resources.contests.banner.body)}
              </div>
            </div>
            <div className="contest-top-banner-image">
              <img
                src={BannerImg}
                alt={translate(resources.contests.banner.title)}
              />
            </div>
          </div>
        </div>
        <div className="contest-banner-list">
          {contests.map(e => (
            <ContestBanner key={e.contestId} contest={e} />
          ))}
        </div>
      </div>
    </section>
  );
};
